import axios from 'axios';
import { PREFIX_URL } from './config';

const URLS = {}

URLS.BASE_URL = `${PREFIX_URL}/conversation`;
URLS.LIST = `${URLS.BASE_URL}/list`;
URLS.ADD = `${URLS.BASE_URL}/comment`;
URLS.UPDATE = `${URLS.BASE_URL}/updateConversation`;

export const fetchList = async(projectId, limit, page) => {     
    const params = {
        projectId,
        limit,
        page
    }

    return await axios.get(URLS.LIST, {params})
      .then(res => res.data);
}

export const addComment = async(postParams) => {
    return await axios.post(URLS.ADD, postParams)
    .catch(error => {
        console.log(error);
    });
}

export const updateComment = async(id, params) => {
    const url = `${URLS.UPDATE}/${id}`; 

    return await axios.put(url, params)
    .catch(error => {
        console.log(error);
    });
}

export const deleteComment = async(commentId) => {
    const url = `${URLS.UPDATE}/${commentId}`; 
    const params = { isDeleted: 1 };

    return await axios.put(url, params)
    .catch(error => {
        console.log(error);
    });
}